<template>
  <div>
    <b-modal
      footer="{null}"
      centered
      id="sim_card_gprs_activate"
      title="Activer Internet"
      hide-footer
       no-close-on-esc
      no-close-on-backdrop
    >
      <div>
        <div v-if="!is_ok">
          <div class="modal-header-wrap text-center">
            <i class="kgk-mtn-BW_Icons_MTNMoMo_GlobalConnect_4 modal-header-icon yellow-muted"></i>
            <h3>Activation Internet</h3>
            <p class="text-muted">
              <span>Vous n'arrivez pas à avoir accès à internet ?</span><br />
              Cliquez sur le bouton recevoir les paramètres de configuration internet de MTN directement sur votre SIM.
            </p>
          </div>

          <div class="mt-3 mb-3 text-center">
            <button @click="go()" class="btn btn-primary">
              <b-spinner small v-if="is_loading" label="Loading..."></b-spinner>
              <span v-if="!is_loading">Envoyer</span>
            </button>
          </div>
        </div>

        <div v-if="is_ok" class="text-center modal-success-error-message">
          <i
            class="mdi mdi-check"
          ></i>
          <p class="text-muted"><b>Paramètres envoyés.</b> <br>Les paramètres internet ont été bien envoyés sur votre numéro.</p>
        </div>
      </div>
      <div></div>
    </b-modal>
  </div>
</template>

<script>
import { subscriber } from "@/services/";
export default {
  name: "SimCardActivateGPRS",
  mounted: async function () {},
  data: () => {
    return {
      is_ok: false,
      is_loading: false,
    };
  },
  methods: {
    go: async function () {
      /*if (!confirm(this.utils_get_config_message("unblock_sim_prevent"))) {
        return;
      }*/
      this.is_loading = true;
      var response = await subscriber.gmcvs("gmcvs_activate");
      if (!_.isUndefined(response.activated)) {
        this.is_ok = true;
      }
      this.is_loading = false;
    },
  },
};
</script>
<style scoped lang="css">
#puk_details {
  font-weight: bold;
  font-size: 22px;
  letter-spacing: 2px;
}
</style>